<script>
export default {
  name: 'AoikumoOutletTag',
  props: {
    // A v2 branch: `provider_links.aoikumo` is
    // `{ integration_id, integration_name, external_id }` or null.
    branch: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isConnected() {
      return this.$store.getters['aoikumo/isConnected'];
    },
    link() {
      return this.branch?.provider_links?.aoikumo || null;
    },
    outlet() {
      return this.link?.external_id || null;
    },
    integrationName() {
      return this.link?.integration_name || '';
    },
  },
};
</script>

<template>
  <span v-if="isConnected" class="inline-flex" data-testid="aoikumo-outlet-tag">
    <span
      v-if="outlet"
      data-testid="aoikumo-outlet-tag-linked"
      class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
    >
      {{
        integrationName
          ? $t('AOIKUMO_OUTLET.TAG_LINKED_NAMED', {
              name: integrationName,
              outlet,
            })
          : $t('AOIKUMO_OUTLET.TAG_LINKED', { outlet })
      }}
    </span>
    <span
      v-else
      data-testid="aoikumo-outlet-tag-unlinked"
      class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200"
    >
      {{ $t('AOIKUMO_OUTLET.TAG_NOT_LINKED') }}
    </span>
  </span>
</template>
